import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { DIMENSIONS } from 'src/home/constants';
import { useQueryParameterState } from 'shared/hooks/useQueryParameterState';
import { type Metric } from 'src/home/reportTemplateParameters';
import { DETAILED_TABLE_DEFAULT_OPTIONS, type HomePageTableDimension } from 'src/home/components/utils';
import { z } from 'zod';
export interface HomeDetailedTableQueryState {
  selectedOptions: string[];
  dimensions: HomePageTableDimension[];
  metrics: Metric[];
  setSelectedOptions: (value: string[]) => void;
}
export const useHomeDetailedTableQueryState = availableMetrics => {
  const $ = _c(16);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [...DETAILED_TABLE_DEFAULT_OPTIONS];
    t1 = {
      schema: z.array(z.string()).min(1)
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  const [selectedOptions, setSelectedOptions] = useQueryParameterState("table.options", t0, t1);
  let t2;
  if ($[2] !== availableMetrics) {
    t2 = new Set(availableMetrics);
    $[2] = availableMetrics;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const availableMetricIds = t2;
  let t3;
  if ($[4] !== selectedOptions) {
    t3 = DIMENSIONS.filter(dimension => selectedOptions.includes(dimension));
    $[4] = selectedOptions;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const dimensions = t3;
  let t4;
  if ($[6] !== availableMetricIds || $[7] !== selectedOptions) {
    let t5;
    if ($[9] !== availableMetricIds) {
      t5 = option => availableMetricIds.has(option as Metric);
      $[9] = availableMetricIds;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    t4 = selectedOptions.filter(t5);
    $[6] = availableMetricIds;
    $[7] = selectedOptions;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const metrics = t4;
  let t5;
  if ($[11] !== dimensions || $[12] !== metrics || $[13] !== selectedOptions || $[14] !== setSelectedOptions) {
    t5 = {
      selectedOptions,
      dimensions,
      metrics,
      setSelectedOptions
    };
    $[11] = dimensions;
    $[12] = metrics;
    $[13] = selectedOptions;
    $[14] = setSelectedOptions;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};